import React, { useState } from 'react';
import MarketingShell from '../../components/MarketingShell';

export default function DemoPage() {
  const [sent, setSent] = useState(false);

  const onSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const body = [
      `Name: ${data.get('firstName')} ${data.get('lastName')}`,
      `Company: ${data.get('company')}`,
      `Email: ${data.get('email')}`,
      `Interest: ${data.get('interest')}`,
    ].join('\n');
    window.location.href = `mailto:hello@getupgraded.ai?subject=${encodeURIComponent('Earnings strategy session')}&body=${encodeURIComponent(body)}`;
    setSent(true);
  };

  return (
    <MarketingShell
      title="Book an earnings strategy session"
      description="See how AI agents, grants, and vendor savings can create more runway."
    >
      <form onSubmit={onSubmit} className="space-y-4 rounded-xl border border-gray-100 bg-white p-6">
        <div className="grid gap-4 sm:grid-cols-2">
          <label className="block text-xs font-medium text-gray-700">
            First name
            <input name="firstName" required className="mt-1 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-900 focus:border-gray-900 focus:outline-none focus:ring-1 focus:ring-gray-900" />
          </label>
          <label className="block text-xs font-medium text-gray-700">
            Last name
            <input name="lastName" required className="mt-1 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-900 focus:border-gray-900 focus:outline-none focus:ring-1 focus:ring-gray-900" />
          </label>
        </div>
        <label className="block text-xs font-medium text-gray-700">
          Company
          <input name="company" required className="mt-1 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-900 focus:border-gray-900 focus:outline-none focus:ring-1 focus:ring-gray-900" />
        </label>
        <label className="block text-xs font-medium text-gray-700">
          Work email
          <input name="email" type="email" required className="mt-1 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-900 focus:border-gray-900 focus:outline-none focus:ring-1 focus:ring-gray-900" />
        </label>
        <label className="block text-xs font-medium text-gray-700">
          I am interested in
          <select name="interest" className="mt-1 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-900 focus:border-gray-900 focus:outline-none focus:ring-1 focus:ring-gray-900">
            <option>A partnership</option>
            <option>Grants and tax credits</option>
            <option>Software savings</option>
            <option>AI automations</option>
          </select>
        </label>
        <button type="submit" className="inline-flex items-center rounded-lg bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-800 transition-colors">
          {sent ? 'Opening email' : 'Request a session'}
        </button>
      </form>
    </MarketingShell>
  );
}
